import React from 'react';
import { Alert, ProgressBar, Spinner } from 'react-bootstrap';
import { formatElapsedDuration } from '../../hooks/useLongRunningProgress';
import './LongRunningOperationBanner.css';

const LongRunningOperationBanner = ({
    show,
    title,
    message,
    elapsedSeconds = 0,
    elapsedLabel,
    expectedDuration,
    hint,
    longWaitNote,
    sticky = false,
}) => {
    if (!show) return null;

    return (
        <Alert
            variant="info"
            className={`lro-banner${sticky ? ' lro-banner--sticky' : ''}${longWaitNote ? ' lro-banner--long-wait' : ''}`}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className="lro-banner__header">
                <Spinner animation="border" size="sm" className="lro-banner__spinner" aria-hidden />
                <strong className="lro-banner__title">{title}</strong>
                {elapsedLabel && (
                    <span className="lro-banner__elapsed">
                        {elapsedLabel}: {formatElapsedDuration(elapsedSeconds)}
                    </span>
                )}
            </div>
            {expectedDuration && (
                <p className="lro-banner__expected mb-1">{expectedDuration}</p>
            )}
            {message && <p className="lro-banner__message mb-2">{message}</p>}
            <ProgressBar animated now={100} className="lro-banner__bar" />
            {longWaitNote && (
                <p className="lro-banner__long-wait mb-1" role="status">{longWaitNote}</p>
            )}
            {hint && <p className="lro-banner__hint mb-0">{hint}</p>}
        </Alert>
    );
};

export default LongRunningOperationBanner;
